import { createFileRoute, notFound } from '@tanstack/react-router';
import { AssessPage } from '../../features/assessment/AssessPage';

export const Route = createFileRoute('/_app/assess/$groupId')({
  params: {
    parse: ({ groupId }) => {
      if (!/^g[1-9]$/.test(groupId)) throw notFound();
      return { groupId };
    },
  },
  component: function AssessRoute() {
    const { groupId } = Route.useParams();
    return <AssessPage groupId={groupId} />;
  },
});
